import React, { Ref } from 'react';
import { forgeClassHelper } from '../utils/classes';
import AttentionSmall from '@athena/forge-icons/dist/AttentionSmall';
import CriticalSmall from '@athena/forge-icons/dist/CriticalSmall';
import forwardRefToProps from '../utils/forwardRefToProps';

const classes = forgeClassHelper('form-error');
const statusIconMap = {
  attention: AttentionSmall,
  critical: CriticalSmall,
};

export type FormErrorAlertType = 'attention' | 'critical';

export interface FormErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Adds a class to the root element of the component */
  className?: string;
  /** Styles to the type of alert */
  alertType?: FormErrorAlertType;
  /** Content to appear inside of Form Error */
  children: React.ReactNode;
  /** Ref to top-level div */
  forwardedRef?: Ref<HTMLDivElement>;
}

/** Displays an error message in conjunction with a FormField.
 *
 * @documentedBy FormField
 */
const FormError = ({
  alertType = 'attention',
  children,
  className,
  forwardedRef,
  ...rest
}: FormErrorProps): React.ReactElement => {
  let IconComponent;
  if (alertType) {
    IconComponent = statusIconMap[alertType];
  }

  return (
    <div
      ref={forwardedRef}
      {...rest}
      {...classes({
        modifiers: alertType,
        extra: className,
      })}
    >
      {IconComponent && <IconComponent {...classes('icon')} />}
      <div {...classes('content')}>{children}</div>
    </div>
  );
};
FormError.displayName = 'FormError';

export default forwardRefToProps(FormError);
